import { render, staticRenderFns } from "./LegendDrawer.vue?vue&type=template&id=1304bee4&"
import script from "./LegendDrawer.vue?vue&type=script&lang=js&"
export * from "./LegendDrawer.vue?vue&type=script&lang=js&"
import style0 from "./LegendDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1304bee4', component.options)
    } else {
      api.reload('1304bee4', component.options)
    }
    module.hot.accept("./LegendDrawer.vue?vue&type=template&id=1304bee4&", function () {
      api.rerender('1304bee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LegendDrawer.vue"
export default component.exports